// store.providers.ts
import { importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FutureActivityEffects } from './data-access/+state/effects/future-activities.effects';
import { StatusTrackerEffects } from './data-access/+state/effects/status-tracker.effects';
import { SummaryContentEffects } from './data-access/+state/effects/summary-content.effects';
import { reducer } from './data-access/+state/reducers/status-tracker.reducer';

export const provideStore = () =>
  makeEnvironmentProviders([
    importProvidersFrom(
      StoreModule.forFeature('statusTracker', reducer),
      EffectsModule.forFeature([
        StatusTrackerEffects,
        FutureActivityEffects,
        SummaryContentEffects
      ])
    ),
    StatusTrackerEffects,
    FutureActivityEffects,
    SummaryContentEffects
  ]);
